<div class="wrapper-page wrapper-my-list">
  <!-- <tl-header></tl-header> -->
  <div class="wrapper-header-my-lists">
    <div class="header-my-lists">
      <h1>{{'NEW_TEXT.delete_my_data' | translate}}</h1>
    </div>
  </div>
  <div class="wrapper-content-my-lists favorite-lists">
    <div class="content-my-lists">
      <div class="content-privacy-policy">
        <p>{{'NEW_TEXT.delete_my_data_text1' | translate}}</p>
        <p>{{'NEW_TEXT.delete_my_data_text2' | translate}} <a href="mailto:dmd@thelysts.com">{{'NEW_TEXT.delete_my_data' | translate}}</a>.</p>
        <p>{{'NEW_TEXT.delete_my_data_text3' | translate}} <br>
          {{'NEW_TEXT.delete_my_data_text4' | translate}}<br>
          {{'NEW_TEXT.delete_my_data_text5' | translate}}</p>
        <p>{{'NEW_TEXT.delete_my_data_text6' | translate}}</p>
        <p>{{'NEW_TEXT.delete_my_data_text7' | translate}}</p>
        <p>{{'NEW_TEXT.delete_my_data_text8' | translate}}</p>
        <p>{{'NEW_TEXT.delete_my_data_text9' | translate}} <a href="mailto:support@thelysts.com">{{'NEW_TEXT.delete_my_data_text10' | translate}}</a>.</p>
      </div>
    </div>
  </div>
</div>

